import { ReactElement } from 'react'

import { ExpandedRowsContextProvider } from '@features/reports/contexts/expandedRowsContext'
import { BalanceSheetReport } from '@features/reports/views/NL/balanceSheetReport'
import { useBalanceSheetData } from '@features/reports/views/NL/balanceSheetReport/hooks/useBalanceSheetData'

export const BalanceSheet = (): ReactElement => {
  const { allExpandableIds } = useBalanceSheetData()

  return (
    <ExpandedRowsContextProvider allExpandableIds={allExpandableIds}>
      <BalanceSheetReport />
    </ExpandedRowsContextProvider>
  )
}
